import { render, staticRenderFns } from "./WeimarLevel.vue?vue&type=template&id=519a32ef&scoped=true&"
import script from "./WeimarLevel.vue?vue&type=script&lang=js&"
export * from "./WeimarLevel.vue?vue&type=script&lang=js&"
import style0 from "./WeimarLevel.vue?vue&type=style&index=0&id=519a32ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a32ef",
  null
  
)

export default component.exports